import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

interface Props {
  children: ReactNode;
  allowAnonymous?: boolean;
  /** If true, only requires login (no credit check). */
  requireAuthOnly?: boolean;
}

/**
 * Gate that requires login. With credits, we no longer block users at the
 * route level just because they have no plan — credit checks happen per-action.
 * Admins always pass.
 */
export default function PaywallGate({ children, allowAnonymous = false }: Props) {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user && !allowAnonymous) {
    return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
